import { ArrowDropDown, Download } from "@mui/icons-material";
import { ListItemIcon } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { Fragment, useState } from "react";

import HNSColors from "../../../../../../../ui library/HNSColors";

import ReportModal from "./ReportModal";

const ActionsButton = ({ reportData, reportId, filters }) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <div id="Actions-Button" data-testid="Actions-Button">
        <PopupState variant="popover" popupId="actions-popup-menu">
          {(popupState) => (
            <Fragment>
              <Button
                className="font-normal capitalize rounded-full"
                sx={{
                  border: "1px solid",
                  color: HNSColors.neutrals[900],
                  backgroundColor: HNSColors.secondary[500],
                  borderColor: HNSColors.secondary[500],
                  "&:hover": {
                    borderColor: HNSColors.secondary[500],
                    backgroundColor: HNSColors.secondary[600],
                  },
                }}
                variant="outlined"
                {...bindTrigger(popupState)}
              >
                Actions
                <ArrowDropDown />
              </Button>
              <Menu {...bindMenu(popupState)}>
                <MenuItem onClick={() => setOpenModal(true)}>
                  <ListItemIcon>
                    <Download fontSize="small" />
                  </ListItemIcon>
                  Download Report
                </MenuItem>
              </Menu>
            </Fragment>
          )}
        </PopupState>
      </div>
      {openModal && (
        <ReportModal
          setOpenModal={setOpenModal}
          reportData={reportData}
          reportId={reportId}
          filters={filters}
        />
      )}
    </>
  );
};

export default ActionsButton;
